/**
 * Whether a key press belongs to what has the focus rather than to the video page's shortcuts: typing in a field
 * (Backspace in "Tell it what it missed" must not remove the picked object), a slider's arrows, and Enter or Space
 * on a button (Enter on Cancel in the add confirm must not add). Letters and arrows on a button stay shortcuts.
 */
const TYPING = /^(INPUT|TEXTAREA|SELECT)$/;
const PRESSABLE =
	'button,a,[role="button"],[role="menuitem"],[role="option"],[role="checkbox"],[role="radio"]';

export const keyBelongsToFocus = (
	e,
	el = typeof document === 'undefined' ? null : document.activeElement
) => {
	if (!el || el === el.ownerDocument?.body) return false;
	if (TYPING.test(el.tagName || '') || el.isContentEditable) return true;
	if (el.closest?.('[role="slider"]')) return true;
	return (e.key === 'Enter' || e.key === ' ') && !!el.closest?.(PRESSABLE);
};
